import React, { createElement } from 'react';
import Text from '../../../03_organisms/BodyBlocks/Text/BBText';

type Props = {
  label?: string;
  description?: string;
  name: string;
  children: ChildrenFielsetField[];
};

type ChildrenFielsetField = {
  props: object & { name: string };
  component: string;
};

const FieldsetField = ({ children, label = '', description = '', name }: Props) => (
  <div id={name}>
    {label && <h3 className="h3">{label}</h3>}
    {description && <Text text={description} />}

    {children.map((item) => {
      return createElement(item.component, {
        key: item.props.name,
        ...item.props,
      });
    })}
  </div>
);

export default FieldsetField;
